export const MOBILE_TAB_PRIORITY = [
  'details',
  'announcements',
  'posts',
  'businesses',
  'events',
  'reviews',
  'property',
  'ads',
  'institutes',
  'mosques',
  'places',
  'free-items',
];

export const sortMobileTabs = (items) => {
  const priorityMap = new Map(MOBILE_TAB_PRIORITY.map((id, index) => [id, index]));
  return [...items].sort((a, b) => {
    const ai = priorityMap.has(a.id) ? priorityMap.get(a.id) : Number.MAX_SAFE_INTEGER;
    const bi = priorityMap.has(b.id) ? priorityMap.get(b.id) : Number.MAX_SAFE_INTEGER;
    return ai - bi;
  });
};

export const getNextTabIndex = ({ currentIndex, key, itemCount }) => {
  if (itemCount <= 0) return -1;
  if (key === 'ArrowRight') return (currentIndex + 1) % itemCount;
  if (key === 'ArrowLeft') return (currentIndex - 1 + itemCount) % itemCount;
  if (key === 'Home') return 0;
  if (key === 'End') return itemCount - 1;
  return currentIndex;
};
